// extracted by mini-css-extract-plugin
module.exports = {"table":"_2EHfsYSSSYLP_x_wCSYzCM"};